import { Box, Grid } from '@material-ui/core';
import { useStyles } from './styles';
import { PlanCardV2 } from './PlanCard';
import { planContentList } from './const';
export const PlanSection = () => {
  const classes = useStyles();
  return (
    <>
      <Box className={classes.PlanSection}>
        <Grid container spacing={4}>
          {planContentList.map((data, index) => {
            return (
              <Grid item xs={12} lg={index === 2 ? 12 : 6}>
                <PlanCardV2 data={data} />
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </>
  );
};
